module.exports = ".sections {\n  position: absolute;\n  top: 130px;\n  left: 10px;\n  right: 10px;\n  bottom: 10px;\n  overflow: auto; }\n"